import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import axios from 'axios';
import Swal from 'sweetalert2';

const CheckoutForm = ({ selectedPackage, subscriptionId, clientSecret, onClose }) => { // <-- Destructure clientSecret here
    const stripe = useStripe();
    const elements = useElements();
    const [isProcessing, setIsProcessing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

   const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
        return;
    }

    setIsProcessing(true);
    setErrorMessage('');

    const isTrialSetup = clientSecret && clientSecret.startsWith('seti_');

    let confirmError;
    let stripeResult;

    // 1. CRITICAL CHECK: Ask Elements what the current status is before confirming!
    const { error: submitError } = await elements.submit();
    if (submitError) {
        setErrorMessage(submitError.message);
        setIsProcessing(false);
        return;
    }

    try {
        // Retrieve the current status of the intent directly from Stripe
        let currentIntent;
        if (isTrialSetup) {
            const { setupIntent } = await stripe.retrieveSetupIntent(clientSecret);
            currentIntent = setupIntent;
        } else {
            const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
            currentIntent = paymentIntent;
        }

        // 2. If it has ALREADY succeeded, skip calling confirm altogether!
        if (currentIntent && currentIntent.status === 'succeeded') {
            stripeResult = currentIntent;
        } else {
            // Otherwise, run the normal confirmation flow
            if (isTrialSetup) {
                const result = await stripe.confirmSetup({
                    elements,
                    confirmParams: {
                        return_url: window.location.origin + "/payment-processing",
                    },
                    redirect: 'if_required'
                });
                confirmError = result.error;
                stripeResult = result.setupIntent;
            } else {
                const result = await stripe.confirmPayment({
                    elements,
                    confirmParams: {
                        return_url: window.location.origin + "/payment-processing",
                    },
                    redirect: 'if_required'
                });
                confirmError = result.error;
                stripeResult = result.paymentIntent;
            }
        }

        if (confirmError) {
            setErrorMessage(confirmError.message);
            setIsProcessing(false);
            return;
        }

        // 3. Finalize on your backend server
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/confirm-payment`,
            { 
                payment_intent_id: !isTrialSetup ? stripeResult?.id : null,
                subscription_id: subscriptionId              
            },
            { withCredentials: true }
        );


        if (response.data.status) {
            if (response.data.user) {
                localStorage.setItem('@roampays-user', JSON.stringify(response.data.user));
                window.dispatchEvent(new Event('user-subscription-updated'));
            }
                        onClose();
           Swal.fire({
        icon: 'success',
        title: 'Subscription Activated!',
        text: response.data.message || 'Your premium access is now live.',
        confirmButtonColor: '#ffc107', // Matches your project's warning/yellow accent button style
        confirmButtonText: 'Great!'
    }).then((result) => {
        // This executes immediately when the user dismisses the SweetAlert box
        window.location.reload();
    });
    
        } else {
            setErrorMessage(response.data.message || "Failed to finalize subscription record.");
        }

    } catch (err) {
        console.error("Verification processing error:", err);
        setErrorMessage("An unexpected error occurred during confirmation.");
    }

    setIsProcessing(false);
};

    return (
        <form onSubmit={handleSubmit} className="p-12">
            
            <div className="payment-element-wrapper mb-16">
                <PaymentElement />
            </div>
            
            {errorMessage && (
                <div className="color-red fs-14 mt-12 mb-12 text-center">
                    {errorMessage}
                </div>
            )}

            <button   
                type="submit"    
                disabled={!stripe || isProcessing}   
                className="btn btn-secondary w-100 mt-12" 
            >
                {isProcessing ? "Processing Securely..." : 
                 selectedPackage.trial_period > 0 ? "Start Free Trial" : `Pay $${selectedPackage.amount} Now`}
            </button>
        </form>
    );
};

export default CheckoutForm;